/**
 * Formats boolean values.
 * @param {Boolean} value - Boolean value to be formatted.
 * @param {String} options.displayTrue - Display name when value is true.
 * @param {String} options.displayFalse - Display name when value is false.
 * @param {String} options.displayNull - Display name when value is null.
 * @param {String} options.displayUndefined - Display name when value is undefined.
 */
function format(value, options) {
  // Get parameters
  const {
    displayTrue,
    displayFalse,
    displayNull,
    displayUndefined
  } = options;

  // Format value
  let formattedValue;
  if (value === true) {
    formattedValue = displayTrue;
  } else if (value === false) {
    formattedValue = displayFalse;
  } else if (value === null) {
    formattedValue = displayNull;
  } else {
    formattedValue = displayUndefined;
  }

  // Return formatted value
  return [formattedValue];
}
export default {
  format
};